import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import {db, auth, functions} from '@/fb'

Vue.config.productionTip = false
let app;
let admin;
auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app') 
  }
})


